// extracted by mini-css-extract-plugin
module.exports = {"filterBody":"NSearchCampus_filterBody__1YjSC","filterImgContent":"NSearchCampus_filterImgContent__1GrvN"};